import { render, staticRenderFns } from "./AdminWrapper.vue?vue&type=template&id=67ad81a4&"
import script from "./AdminWrapper.vue?vue&type=script&lang=ts&"
export * from "./AdminWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports